module.exports = __webpack_public_path__ + "pic/21.437f0c70.png";